import { createModuleHttpClient } from '../../createModuleHttpClient';
import paymentModule from '../index';

const client = createModuleHttpClient(paymentModule.id);

export default client;
